module.exports = [{"code":0,"name":"车头图片"},{"code":1,"name":"车尾图片"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/frontRear.json
// module id = LlPW
// module chunks = 11